{
  "Common": {
    "close": "닫기",
    "closeAlert": "알림 닫기",
    "notifications": "알림",
    "newNotification": "새로운",
    "readStatus": "읽음",
    "openLink": "링크 열기",
    "theme": "테마",
    "lightTheme": "라이트",
    "darkTheme": "다크",
    "systemTheme": "시스템",
    "density": "밀도",
    "compact": "컴팩트",
    "normal": "보통",
    "comfortable": "여유",
    "columns": "열",
    "loading": "로딩 중",
    "noData": "데이터 없음",
    "clearFilter": "필터 지우기",
    "selectAll": "전체 선택",
    "default": "기본값",
    "other": "기타",
    "headerAlign": "헤더 정렬",
    "alignLeft": "왼쪽 정렬",
    "alignCenter": "가운데 정렬",
    "alignRight": "오른쪽 정렬"
  },
  "ValidationInput": {
    "required": "필수 입력 항목입니다",
    "typeMismatch": "형식이 올바르지 않습니다",
    "pattern": "패턴이 일치하지 않습니다",
    "tooShort": "너무 짧습니다",
    "tooLong": "너무 깁니다",
    "rangeUnderflow": "최솟값보다 작습니다",
    "rangeOverflow": "최댓값을 초과했습니다",
    "stepMismatch": "단계가 일치하지 않습니다",
    "badInput": "잘못된 입력입니다",
    "invalid": "유효하지 않은 값입니다"
  },
  "Loading": {
    "loadingPage": "페이지 로딩 중",
    "pleaseWait": "잠시만 기다려 주세요"
  },
  "DatePicker": {
    "placeholder": "날짜 선택",
    "today": "오늘",
    "clear": "지우기"
  },
  "DateTimePicker": {
    "time": "시간",
    "clear": "지우기",
    "done": "완료"
  },
  "CalendarTimeline": {
    "today": "오늘",
    "prev": "이전",
    "next": "다음",
    "month": "월",
    "week": "주",
    "day": "일",
    "sprint": "스프린트",
    "newEvent": "새 이벤트",
    "createEventTitle": "이벤트 생성",
    "create": "생성",
    "cancel": "취소",
    "resource": "리소스",
    "start": "시작",
    "end": "종료",
    "resourcesHeader": "리소스",
    "expandGroup": "그룹 펼치기",
    "collapseGroup": "그룹 접기",
    "more": "+{n}개 더",
    "sprints": "{n} 스프린트",
    "deleteConfirm": "삭제하시겠습니까?"
  },
  "Pagination": {
    "navigationLabel": "페이지 네비게이션",
    "showingResults": "{startItem}–{endItem} / 총 {totalItems}개",
    "firstPage": "첫 페이지",
    "previousPage": "이전 페이지",
    "previous": "이전",
    "nextPage": "다음 페이지",
    "next": "다음",
    "lastPage": "마지막 페이지",
    "pageNumber": "{page}페이지",
    "itemsPerPage": "페이지당 항목 수",
    "search": "검색",
    "noOptions": "옵션 없음"
  },
  "OCR": {
    "imageUpload": {
      "dragDropText": "여기에 파일을 드래그 앤 드롭하세요",
      "browseFiles": "파일 찾아보기",
      "supportedFormats": "지원 형식: 이미지"
    }
  },
  "FileUpload": {
    "dragDropText": "여기에 파일을 드래그 앤 드롭하세요",
    "browseFiles": "파일 선택",
    "uploadFiles": "파일 업로드",
    "supportedFormats": "모든 파일 형식 지원",
    "uploadedFiles": "업로드된 파일",
    "clearAll": "모두 지우기",
    "fileTooLarge": "파일 크기가 제한을 초과했습니다.",
    "maxFilesReached": "최대 파일 수에 도달했습니다.",
    "uploadSuccess": "업로드되었습니다.",
    "uploadFailed": "업로드에 실패했습니다."
  },
  "UEditor": {
    "placeholder": "명령어는 '/'를 입력하거나 입력을 시작하세요...",
    "loading": "에디터 로딩 중...",
    "words": "단어",
    "characters": "자",
    "colors": {
      "default": "기본",
      "muted": "흐림",
      "primary": "기본",
      "secondary": "보조",
      "success": "성공",
      "warning": "경고",
      "destructive": "위험",
      "info": "정보",
      "accent": "강조",
      "textColor": "텍스트 색상",
      "highlight": "형광펜",
      "automatic": "자동",
      "moreColors": "다른 색...",
      "color": "색상",
      "done": "완료"
    },
    "toolbar": {
      "bold": "굵게",
      "boldShortcut": "굵게 (Ctrl+B)",
      "italic": "기울임",
      "italicShortcut": "기울임 (Ctrl+I)",
      "underline": "밑줄",
      "underlineShortcut": "밑줄 (Ctrl+U)",
      "strike": "취소선",
      "code": "코드",
      "subscript": "아래 첨자",
      "superscript": "위 첨자",
      "link": "링크",
      "removeLink": "링크 제거",
      "image": "이미지",
      "table": "표",
      "alignment": "정렬",
      "alignLeft": "왼쪽 정렬",
      "alignCenter": "가운데 정렬",
      "alignRight": "오른쪽 정렬",
      "justify": "양쪽 맞춤",
      "bulletList": "글머리 기호 목록",
      "orderedList": "번호 매기기 목록",
      "taskList": "할 일 목록",
      "quote": "인용구",
      "codeBlock": "코드 블록",
      "undo": "실행 취소",
      "redo": "다시 실행",
      "textStyle": "텍스트 스타일",
      "fontFamily": "글꼴",
      "fontSize": "글자 크기",
      "lineHeight": "줄 간격",
      "fontDefault": "기본 글꼴",
      "sizeDefault": "기본 크기",
      "lineHeightDefault": "기본 줄 간격",
      "letterSpacing": "자간",
      "letterSpacingDefault": "기본 자간",
      "fontSans": "Sans",
      "fontSerif": "Serif",
      "fontMono": "Mono",
      "normal": "일반 텍스트",
      "heading1": "제목 1",
      "heading2": "제목 2",
      "heading3": "제목 3",
      "emoji": "이모지 삽입",
      "imageLayoutBlock": "이미지 블록",
      "imageLayoutLeft": "왼쪽 이미지, 오른쪽 텍스트",
      "imageLayoutRight": "오른쪽 이미지, 왼쪽 텍스트",
      "imageWidthSm": "작은 이미지",
      "imageWidthMd": "중간 이미지",
      "imageWidthLg": "큰 이미지",
      "imageResetSize": "이미지 크기 초기화",
      "imageDelete": "이미지 삭제"
    },
    "slashCommand": {
      "basicBlocks": "기본 블록",
      "text": "텍스트",
      "textDesc": "일반 텍스트 블록",
      "heading1": "제목 1",
      "heading1Desc": "대형 섹션 제목",
      "heading2": "제목 2",
      "heading2Desc": "중형 섹션 제목",
      "heading3": "제목 3",
      "heading3Desc": "소형 섹션 제목",
      "bulletList": "글머리 기호 목록",
      "bulletListDesc": "간단한 글머리 기호 목록",
      "orderedList": "번호 매기기 목록",
      "orderedListDesc": "번호가 매겨진 목록",
      "todoList": "할 일 목록",
      "todoListDesc": "체크박스가 있는 할 일 목록",
      "quote": "인용구",
      "quoteDesc": "인용문 블록",
      "codeBlock": "코드 블록",
      "codeBlockDesc": "구문 강조가 있는 코드",
      "divider": "구분선",
      "dividerDesc": "시각적 구분선",
      "table": "표",
      "tableDesc": "표 추가",
      "noResults": "일치하는 블록이 없습니다",
      "callout": "콜아웃",
      "calloutDesc": "중요한 정보를 콜아웃 블록으로 강조합니다",
      "bookmark": "북마크 카드",
      "bookmarkDesc": "링크를 북마크 카드로 삽입합니다",
      "fileCard": "파일 첨부",
      "fileCardDesc": "파일 카드 첨부 파일을 업로드합니다",
      "formCheckbox": "양식 체크박스",
      "formCheckboxDesc": "대화형 체크박스 필드 삽입",
      "formRadio": "양식 라디오 버튼",
      "formRadioDesc": "대화형 라디오 버튼 필드 삽입"
    },
    "floatingMenu": {
      "addBlock": "블록 추가"
    },
    "linkInput": {
      "placeholder": "링크 붙여넣기 또는 입력..."
    },
    "imageInput": {
      "urlTab": "URL",
      "uploadTab": "업로드",
      "urlLabel": "이미지 URL",
      "urlPlaceholder": "https://example.com/image.jpg",
      "uploadLabel": "이미지 선택",
      "uploadPlaceholder": "클릭하여 이미지 업로드",
      "uploading": "업로드 중...",
      "uploadError": "업로드 실패. 다시 시도해 주세요.",
      "altLabel": "대체 텍스트 (선택 사항)",
      "altPlaceholder": "이미지에 대한 설명...",
      "addBtn": "이미지 추가",
      "cancelBtn": "취소",
      "addFromUrl": "URL에서 추가"
    },
    "emojiPicker": {
      "searchPlaceholder": "이모지 검색",
      "noResults": "이모지를 찾을 수 없습니다",
      "tryDifferentSearch": "다른 검색어를 시도해 보세요"
    },
    "stickerPicker": {
      "searchPlaceholder": "스티커 검색",
      "noResults": "검색된 스티커가 없습니다.",
      "tryDifferentSearch": "다른 검색어를 시도해 보세요"
    },
    "emojiSuggestion": {
      "title": "이모지",
      "noResults": "이모지를 찾을 수 없습니다",
      "showingCount": "총 {total}개 중 처음 {shown}개의 이모지를 표시 중"
    },
    "formulaSuggestion": {
      "title": "함수",
      "noResults": "함수를 찾을 수 없습니다",
      "sum": "범위의 값을 합산",
      "avg": "범위의 값 평균",
      "min": "범위의 최솟값",
      "max": "범위의 최댓값",
      "count": "범위의 숫자 셀 개수"
    },
    "tableMenu": {
      "insert3x3": "3x3 표 삽입",
      "insertTable": "표 삽입",
      "gridPreview": "{rows}×{cols} 표 삽입",
      "addColumnBefore": "앞에 열 추가",
      "addColumnAfter": "뒤에 열 추가",
      "addRowBefore": "위에 행 추가",
      "addRowAfter": "아래에 행 추가",
      "duplicateColumn": "열 복제",
      "duplicateRow": "행 복제",
      "clearColumnContents": "열 내용 지우기",
      "clearRowContents": "행 내용 지우기",
      "deleteColumn": "열 삭제",
      "deleteRow": "행 삭제",
      "deleteTable": "표 삭제",
      "toggleHeaderRow": "헤더 행 전환",
      "toggleHeaderColumn": "헤더 열 전환",
      "mergeCells": "셀 병합",
      "splitCell": "셀 분할",
      "openControls": "표 컨트롤 열기",
      "quickAddColumnAfter": "오른쪽 열 빠르게 추가",
      "quickAddRowAfter": "아래 행 빠르게 추가",
      "expandTable": "표 확장",
      "dragRow": "행 드래그",
      "dragColumn": "열 드래그",
      "alignLeft": "표 왼쪽 정렬",
      "alignCenter": "표 가운데 정렬",
      "alignRight": "표 오른쪽 정렬",
      "cellBackground": "셀 배경색",
      "cellBorder": "셀 테두리",
      "borderStyle": "테두리 스타일",
      "borderWidth": "테두리 두께",
      "borderColor": "테두리 색상",
      "clearBorder": "테두리 지우기",
      "formula": "수식",
      "numberFormat": "표시 형식",
      "formatText": "텍스트",
      "formatDate": "날짜",
      "apply": "적용",
      "clear": "지우기",
      "recalculate": "다시 계산",
      "done": "완료",
      "alignVertical": "세로 맞춤",
      "alignVerticalTop": "위쪽 맞춤",
      "alignVerticalMiddle": "가운데 맞춤",
      "alignVerticalBottom": "아래쪽 맞춤"
    },
    "callout": {
      "selectEmoji": "이모지 선택",
      "backgroundColor": "배경 색상"
    },
    "radio": {
      "groupName": "그룹 이름",
      "editGroup": "그룹 이름 편집"
    },
    "bookmark": {
      "clickToOpenNewTab": "클릭하여 이 링크를 새 탭에서 엽니다.",
      "clickToOpenLink": "클릭하여 링크를 엽니다.",
      "noDescription": "설명이 없습니다.",
      "failedToLoad": "링크 미리보기를 불러오지 못했습니다. 클릭하여 링크를 엽니다.",
      "previewFailed": "미리보기를 불러오지 못했습니다",
      "retryPreview": "다시 시도"
    },
    "fileCard": {
      "unnamed": "이름 없는 파일",
      "uploading": "(업로드 중...)",
      "uploadFailed": "업로드에 실패했습니다.",
      "retryUpload": "다시 업로드"
    },
    "menubar": {
      "file": "파일",
      "edit": "편집",
      "view": "보기",
      "insert": "삽입",
      "format": "서식",
      "tools": "도구",
      "table": "표",
      "save": "저장",
      "exportHtml": "HTML 추출",
      "undo": "실행 취소",
      "undoShortcut": "Ctrl+Z",
      "redo": "다시 실행",
      "redoShortcut": "Ctrl+Y",
      "cut": "잘라내기",
      "cutShortcut": "Ctrl+X",
      "copy": "복사",
      "copyShortcut": "Ctrl+C",
      "paste": "붙여넣기",
      "pasteShortcut": "Ctrl+V",
      "pasteAsText": "일반 텍스트로 붙여넣기",
      "selectAll": "전체 선택",
      "selectAllShortcut": "Ctrl+A",
      "sourceCode": "소스 코드",
      "preview": "미리보기",
      "fullscreen": "전체 화면",
      "fullscreenShortcut": "Ctrl+Shift+F",
      "image": "이미지",
      "link": "링크",
      "linkShortcut": "Ctrl+K",
      "insertTable": "표",
      "horizontalRule": "가로줄",
      "bold": "굵게",
      "boldShortcut": "Ctrl+B",
      "italic": "기울임꼴",
      "italicShortcut": "Ctrl+I",
      "underline": "밑줄",
      "underlineShortcut": "Ctrl+U",
      "strike": "취소선",
      "superscript": "위 첨자",
      "subscript": "아래 첨자",
      "code": "코드",
      "wrap": "블록",
      "align": "정렬",
      "clearFormatting": "서식 지우기",
      "paragraph": "단락",
      "heading1": "제목 1",
      "heading2": "제목 2",
      "heading3": "제목 3",
      "blockquote": "인용",
      "codeBlock": "코드 블록",
      "taskList": "작업 목록",
      "alignLeft": "왼쪽",
      "alignCenter": "가운데",
      "alignRight": "오른쪽",
      "alignJustify": "양쪽",
      "tableProperties": "표 속성",
      "deleteTable": "표 삭제",
      "row": "행",
      "column": "열",
      "cell": "셀",
      "addRowBefore": "위에 행 삽입",
      "addRowAfter": "아래에 행 삽입",
      "deleteRow": "행 삭제",
      "addColumnBefore": "왼쪽에 열 삽입",
      "addColumnAfter": "오른쪽에 열 삽입",
      "deleteColumn": "열 삭제",
      "mergeCells": "셀 병합",
      "splitCell": "셀 분할",
      "imageUpload": "이미지 업로드",
      "formFields": "양식 필드",
      "formCheckbox": "양식 체크박스",
      "formRadio": "양식 라디오 버튼",
      "applySource": "적용",
      "closeDialog": "닫기",
      "copyHtml": "HTML 복사",
      "exportDefault": "HTML 추출",
      "previewEmpty": "미리볼 내용이 없습니다.",
      "sourceCodeHint": "HTML을 직접 편집하고 적용을 클릭하여 에디터를 업데이트하세요."
    }
  }
}
